import { render } from "./UploadMeasurement.vue?vue&type=template&id=284dfc8b&scoped=true"
import script from "./UploadMeasurement.vue?vue&type=script&lang=js"
export * from "./UploadMeasurement.vue?vue&type=script&lang=js"

import "./UploadMeasurement.vue?vue&type=style&index=0&id=284dfc8b&scoped=true&lang=css"

import exportComponent from "/home/chris/Documents/HELSINKI/Uni_IFT/truscanWebapp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-284dfc8b"]])

export default __exports__